import Button from '@components/atoms/button'
import { FastlyImage } from '@components/common/image'
import { CourseVideoType } from '@components/locale-pages/home/courses'
import { Dispatch, SetStateAction } from 'react'
type Props = {
  setModalOpen: Dispatch<SetStateAction<boolean>>
  setVideoURL: Dispatch<SetStateAction<string>>
  video: CourseVideoType
}
const RecommendedCoursesVideo = ({
  setModalOpen,
  setVideoURL,
  video,
}: Props) => {
  const handleVideoPlay = () => {
    setModalOpen(true)
    setVideoURL(video.url)
  }
  return (
    <div
      className="w-80 max-w-full shadow hover:shadow-lg border border-grey-400 rounded-md cursor-pointer bg-white"
      onClick={handleVideoPlay}
    >
      <FastlyImage
        src={`/images/courses/${video.image}.jpg`}
        alt={video.altText}
        className="w-full"
        width={400}
        height={400}
      />
      <p className="text-center text-grey-700 my-2 text-2xl font-600">
        {video.title}
      </p>
      <div className="p-3 pt-0">
        <div onClick={handleVideoPlay}>
          <Button className="w-full p-0" variant="solid">
            Watch video
          </Button>
        </div>
      </div>
    </div>
  )
}

export default RecommendedCoursesVideo
